"use client";

import styled from "styled-components";

export const MainBannerWrapper = styled.div<{ $imageUrl: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 3.2rem 0 3.2rem;

  background-image: url(${({ $imageUrl }) => $imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: -2;
  }

  .article-detail-mobile-ui-true & {
    padding: 1.6rem 0 1.6rem;
  }

  @media only screen and (max-width: 768px) {
    padding: 1.6rem 0 1.6rem;
  }
`;

export const SectionAndMarketWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .article-detail-mobile-ui-true & {
    align-items: flex-start;
  }

  @media only screen and (max-width: 768px) {
    align-items: flex-start;
  }
`;

export const MainBannerContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.4rem;

  width: calc(100% - 3.2rem);
  max-width: 100rem;
  height: 100%;

  .article-detail-mobile-ui-true & {
    gap: 1.2rem;
  }

  @media only screen and (max-width: 768px) {
    gap: 1.2rem;
  }
`;

export const ArticleSectionText = styled.div`
  font-family: var(--font-pretendard);
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 100%;

  .article-detail-mobile-ui-true & {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const MarketInfoWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;

  .article-detail-mobile-ui-true & {
    flex-direction: column;
    align-items: flex-end;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;
export const SameDayText = styled.div`
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);

  font-size: 1.2rem;
  font-weight: 500;

  .article-detail-mobile-ui-true & {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
  width: 100%;
  height: 2rem;
`;

export const MobileDateWrapper = styled.div`
  display: none;

  .article-detail-mobile-ui-true & {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.2rem;
    width: 100%;
    height: 2rem;
  }
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.2rem;
    width: 100%;
    height: 2rem;
  }
`;

export const DateText = styled.div`
  height: 100%;
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  font-size: 1.6rem;
  font-weight: 600;
  font-family: var(--font-pretendard);
  line-height: 2.2rem;

  .article-detail-mobile-ui-true & {
    font-size: 1.2rem;
    font-weight: 500;
  }

  @media only screen and (max-width: 768px) {
    font-size: 1.2rem;
    font-weight: 500;
  }
`;

export const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1.2rem;

  width: 100%;

  .article-detail-mobile-ui-true & {
    align-items: flex-start;
    flex-direction: column;
    gap: 1.2rem;
  }

  @media only screen and (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 1.2rem;
  }
`;

export const TitleLogoWrapper = styled.div`
  .article-detail-mobile-ui-true & {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const Title = styled.div`
  flex: 1;
  font-family: var(--font-pt-serif);
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  font-size: 2rem;
  font-weight: 400;
  line-height: 135%;
`;

export const MainLabelWrapper = styled.div`
  width: 100%;
`;

export const UrlWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  width: fit-content;
  min-width: 22rem;
  height: 2rem;
  color: var(--Color-Common-Text-Interactive-Inverse, #fff) !important;
  text-align: center;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  text-decoration: underline !important;
  cursor: pointer;
  white-space: nowrap;

  path {
    fill: var(--Color-Common-Text-Interactive-Inverse, #fff) !important;
  }
`;

export const BottomRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .article-detail-mobile-ui-true & {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
